// `color` is the legacy MUI colour name (kept for existing consumers). New code
// should use `token`, a key into theme.palette.acmg: MUI colours cannot tell
// Likely pathogenic from VUS, or Benign from "not classified".
const createAcmgSeverityEntry = (value, description, order, color, token) => [
  value,
  { value, description, order, color, token },
]

export const ACMG_SEVERITY = Object.fromEntries([
  createAcmgSeverityEntry('Uncertain significance', 'VUS', -1, 'warning', 'vus'),
  createAcmgSeverityEntry('Benign', 'Benign', 0, 'default', 'benign'),
  createAcmgSeverityEntry('Likely benign', 'Likely benign', 1, 'success', 'likelyBenign'),
  createAcmgSeverityEntry('Likely pathogenic', 'Likely pathogenic', 2, 'warning', 'likelyPathogenic'),
  createAcmgSeverityEntry('Pathogenic', 'Pathogenic', 3, 'error', 'pathogenic'),
])

export const ACMG_CHOICES = {
  DESCRIPTIONS: [
    { label: 'VUS', value: 'Uncertain significance' },
    { label: 'Benign', value: 'Benign' },
    { label: 'Likely benign', value: 'Likely benign' },
    { label: 'Likely pathogenic', value: 'Likely pathogenic' },
    { label: 'Pathogenic', value: 'Pathogenic' },
  ],
}

// ----------------------------------------------------------------------
// theme.palette.acmg keys. Every shape the backend uses maps to one of these:
// long form ("Likely pathogenic"), shorthand ("LP"), severity int (1..5).
export const ACMG_TOKEN_KEYS = ['pathogenic', 'likelyPathogenic', 'vus', 'likelyBenign', 'benign', 'none']

export const ACMG_SHORTHAND_TOKEN = {
  P: 'pathogenic',
  LP: 'likelyPathogenic',
  VUS: 'vus',
  LB: 'likelyBenign',
  B: 'benign',
}

const LONG_FORM_TOKEN = {
  pathogenic: 'pathogenic',
  'likely pathogenic': 'likelyPathogenic',
  'uncertain significance': 'vus',
  uncertain: 'vus',
  'likely benign': 'likelyBenign',
  benign: 'benign',
}

const SEVERITY_INT_TOKEN = { 1: 'benign', 2: 'likelyBenign', 3: 'vus', 4: 'likelyPathogenic', 5: 'pathogenic' }

/** Resolve any ACMG classification to a theme.palette.acmg key ('none' when unknown). */
export const acmgTokenKey = (classification) => {
  if (classification == null || classification === '') return 'none'
  if (typeof classification === 'number') return SEVERITY_INT_TOKEN[classification] || 'none'
  const s = String(classification).trim()
  return ACMG_SHORTHAND_TOKEN[s.toUpperCase()] || LONG_FORM_TOKEN[s.toLowerCase().replace(/_/g, ' ')] || 'none'
}
